<script setup lang="ts">
import { defineProps, toRefs } from 'vue'

const props = defineProps<{sources: Array<{ plain: string; html: string }> }>()
const { sources } = toRefs(props)

const extractListItems = (html: string): string[] => {
  if (typeof window === 'undefined') return []
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html
  let items = Array.from(tempDiv.querySelectorAll('li')).map((li) => li.innerHTML)
  if (items.length === 0) {
    items = Array.from(tempDiv.querySelectorAll('p')).map((p) => `<li>${p.innerHTML}</li>`)
  }
  return items
}
</script>

<template>
  <div class="flex flex-col items-start gap-2.5
              pb-6 pl-1 md:pl-1.5 md:pb-8
              font-body text-body-md md:text-body-lg">
    <ul class="pl-4 list-disc">
      <template v-for="(source, index) in sources">
        <li v-for="(item, subIndex) in extractListItems(source.html)"
            :key="`item-${index}-${subIndex}`"
            class="prose prose-a:text-secondary-500 hover:prose-a:text-primary-350 prose-a:decoration-from-font prose-a:underline-offset-2
            text-body-md md:text-body-lg
            prose-a:focus-visible:outline-secondary-500 focus-visible:prose-a:ring focus-visible:prose-a:ring-offset-1 focus-visible:prose-a:ring-ring focus-visible:prose-a:outline-0 "
            v-html="item" />
      </template>
    </ul>
  </div>
</template>
